
/**
 * The type of Redux action which clears all the data of every sessions.
 *
 * {
 *     type: CLEAR_RECORDING_SESSIONS
 * }.
 *
 * @public
 */
export const CLEAR_RECORDING_SESSIONS = 'CLEAR_RECORDING_SESSIONS';

/**
 * The type of Redux action which updates the current known state of a recording
 * session.
 *
 * {
 *     type: RECORDING_SESSION_UPDATED,
 *     sessionData: Object
 * }.
 *
 * @public
 */
export const RECORDING_SESSION_UPDATED = 'RECORDING_SESSION_UPDATED';

/** Add commentMore actions
 * The type of (redux) action which indicates if the user set the state of
 * the subtitles to enabled or disabled.
 *
 * {
 *      type: RECORDING_CONSENT_DIALOG_ID
 *      enabled: boolean
 * }
 */
export const RECORDING_CONSENT_DIALOG_ID = 'recordingConsentDialog';

/**
 * The type of Redux action which sets the pending recording notification UID to
 * use it for when hiding the notification is necessary, or unsets it when
 * undefined (or no param) is passed.
 *
 * {
 *     type: SET_PENDING_RECORDING_NOTIFICATION_UID,
 *     streamType: string,
 *     uid: ?number
 * }.
 *
 * @public
 */
export const SET_PENDING_RECORDING_NOTIFICATION_UID
    = 'SET_PENDING_RECORDING_NOTIFICATION_UID';

/**
 * Sets the stream key last used by the user for later reuse.
 *
 * {
 *     type: SET_STREAM_KEY,
 *     streamKey: string
 * }.
 */
export const SET_STREAM_KEY = 'SET_STREAM_KEY';

/**
 * Sets the recording mode.
 *
 * {
 *     type: RECORDING_MODE,
 *     mode: string
 * }.
 */
export const RECORDING_MODE = 'RECORDING_MODE';

export const LIVESTREAM_OBJECT = 'LIVESTREAM_OBJECT';

/**
 * The type of Redux action which stores the live stream keys fetched from the
 * API.
 *
 * {
 *     type: SET_AUTO_LIVE_STREAM_KEYS,
 *     streamKeys: Object
 * }.
 */
export const SET_AUTO_LIVE_STREAM_KEYS = 'SET_AUTO_LIVE_STREAM_KEYS';

/**
 * Starts local recording.
 *
 * {
 *     type: START_LOCAL_RECORDING,
 *     onlySelf: boolean
 * }
 */
export const START_LOCAL_RECORDING = 'START_LOCAL_RECORDING';

/**
 * Stops local recording.
 *
 * {
 *     type: STOP_LOCAL_RECORDING
 * }
 */
export const STOP_LOCAL_RECORDING = 'STOP_LOCAL_RECORDING';

/**
 * Marks a recording session as "stop requested" so that incoming XMPP
 * PENDING/ON events (from Jibri still transitioning) are suppressed until
 * the server confirms the stop with an OFF event.
 *
 * {
 *     type: RECORDING_STOP_REQUESTED,
 *     sessionId: string
 * }
 */
export const RECORDING_STOP_REQUESTED = 'RECORDING_STOP_REQUESTED';

/**
 * Clears the "stop requested" tracking for a session once the server
 * confirms the OFF status via RECORDER_STATE_CHANGED.
 *
 * {
 *     type: RECORDING_STOP_CLEARED,
 *     sessionId: string
 * }
 */
export const RECORDING_STOP_CLEARED = 'RECORDING_STOP_CLEARED';
